import { render, staticRenderFns } from "./AgencyUserList.vue?vue&type=template&id=28485d24&scoped=true&"
import script from "./AgencyUserList.vue?vue&type=script&lang=js&"
export * from "./AgencyUserList.vue?vue&type=script&lang=js&"
import style0 from "./AgencyUserList.vue?vue&type=style&index=0&id=28485d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28485d24",
  null
  
)

component.options.__file = "AgencyUserList.vue"
export default component.exports